"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _StyledSkeletonLoader = require("./Components/StyledSkeletonLoader.js");
var _CommonUtility = require("../../../utils/CommonUtility.js");
var _themeProvider = require("../../../theme/themeProvider/index.js");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
const SkeletonLoader = props => {
  const theme = (0, _themeProvider.useTheme)();
  const {
    type = 'LINE',
    count = 1,
    bgColor = theme.color.neutral300,
    containerStyle
  } = props;
  const skeletonLoaderContainer = `skeleton-loader__ ${containerStyle ?? ''}`;
  const [uuid] = (0, _react.useState)((0, _CommonUtility.generateUuidv4)());
  let skeletonWidth = '';
  let skeletonHeight = '';
  if (type === 'LINE') {
    skeletonWidth = '100%';
    skeletonHeight = '1.5em';
  } else if (type === 'CIRCLE') {
    skeletonWidth = '1.5em';
    skeletonHeight = '1.5em';
  }
  const {
    width = skeletonWidth,
    height = skeletonHeight
  } = props;
  const loadSkeleton = () => {
    const element = [];
    for (let i = 0; i < count; i++) {
      element.push(/*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledSkeletonLoader.SkeletonBox, {
        width: width,
        height: height,
        type: type,
        bgColor: bgColor
      }, `${uuid}-skeleton-${i}`));
    }
    return element;
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_StyledSkeletonLoader.SkeletonContainer, {
    className: skeletonLoaderContainer,
    children: loadSkeleton()
  });
};
var _default = exports.default = SkeletonLoader;
module.exports = exports.default;
module.exports.default = exports.default;